import React from 'react';

import getEnvironment from '../../utils/getCurrentEnv';
import resolveEnvTheme from '../../utils/envTheme';
import { Frame, FrameLabel } from './EnvFrame.styled';

// Draws a colored top border and a bold centered label on non-prod
// environments (QA/Staging) so the current environment is always visible.
// Renders nothing for prod / unknown environments.
export default function EnvFrame() {
  const envTheme = resolveEnvTheme(
    getEnvironment(process.env.REACT_APP_BASE_URL),
  );

  if (!envTheme) return null;

  return (
    <>
      <Frame
        data-testid="environment-frame"
        style={{ borderColor: envTheme.color }}
      />
      <FrameLabel
        data-testid="environment-frame-label"
        style={{ backgroundColor: envTheme.color }}
      >
        {envTheme.label} Environment
      </FrameLabel>
    </>
  );
}
